import { render } from "./InputUpload.vue?vue&type=template&id=3ae93c62&scoped=true"
import script from "./InputUpload.vue?vue&type=script&lang=js"
export * from "./InputUpload.vue?vue&type=script&lang=js"

import "./InputUpload.vue?vue&type=style&index=0&id=3ae93c62&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ae93c62"]])

export default __exports__